import { useResponsive } from "@hubcapp/hooks";
import Button from "@ds-developer/button";
import React from "react";

interface IProps {
  closeViewLessonModal: (() => void) | undefined;
  cancelLesson: (() => void) | undefined;
  onSaveButtonClick: () => void;
  onEditButtonClick: () => void;
  showEditButton: boolean;
  showSaveButton: boolean;
  disabledSaveButton: boolean;
  loadingSaveButton: boolean;
}

export const ViewLessonModalActions: React.FC<IProps> = ({
  closeViewLessonModal,
  cancelLesson,
  onSaveButtonClick,
  onEditButtonClick,
  showEditButton,
  showSaveButton,
  disabledSaveButton,
  loadingSaveButton,
}) => {
  const { isMobile } = useResponsive();
  return (
    <>
      <div style={{ flexGrow: 1 }}>
        <Button onClick={closeViewLessonModal} variant="outlined">
          Cancel
        </Button>
      </div>
      <Button color="primary" onClick={cancelLesson} variant="outlined">
        {isMobile ? "Delete" : "Delete lesson"}
      </Button>
      {showEditButton && (
        <Button
          color="primary"
          onClick={onEditButtonClick}
          variant="contained"
          data-test="edit-lesson-button"
        >
          {isMobile ? "Edit" : "Edit lesson"}
        </Button>
      )}
      {showSaveButton && (
        <Button
          color="primary"
          onClick={onSaveButtonClick}
          variant="contained"
          disabled={disabledSaveButton}
          loading={loadingSaveButton}
        >
          {isMobile ? "Save" : "Save lesson"}
        </Button>
      )}
    </>
  );
};
